import { forwardRef } from 'react';
import type React from 'react';

type OwnProps = React.SVGProps<SVGSVGElement> & {
  isSavedSearch: boolean;
};

const HeartIcon = forwardRef<SVGSVGElement, OwnProps>(
  ({ isSavedSearch, ...rest }, ref) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={isSavedSearch ? '#E03131' : 'none'}
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...rest}
    >
      <path
        d="M2.07514 3.06558L2.07529 3.06543C2.77436 2.37849 3.7014 2 4.69925 2C5.68637 2 6.60802 2.37259 7.30268 3.04694L7.99821 3.72213L8.69472 3.04795C10.1421 1.64694 12.4876 1.65297 13.924 3.06453L13.9242 3.0647C15.3552 4.4703 15.3584 6.74863 13.9347 8.15736L7.99439 13.6389L2.06513 8.15963C0.641323 6.74877 0.645273 4.47003 2.07514 3.06558Z"
        stroke={isSavedSearch ? '#E03131' : 'currentColor'}
        strokeWidth="2"
      />
    </svg>
  )
);

export default HeartIcon;
